import axios from "axios";

const clienteAxios = axios.create({
  //baseURL: process.env.baseURL,
  baseURL: 'https://api.pry-fase2.relix.pe/'
});

export default clienteAxios;
